import type { HTMLAttributes } from 'react';
import { cn } from '../utils/cn';

export function Container({
  className,
  size = 'wide',
  ...props
}: HTMLAttributes<HTMLDivElement> & { size?: 'wide' | 'narrow' }) {
  return (
    <div
      className={cn(
        'mx-auto w-full px-5 md:px-8 lg:px-12',
        size === 'narrow' ? 'max-w-[880px]' : 'max-w-[1200px]',
        className,
      )}
      {...props}
    />
  );
}

export function Stack({
  className,
  gap = 'md',
  ...props
}: HTMLAttributes<HTMLDivElement> & { gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }) {
  const gapMap = {
    xs: 'gap-2',
    sm: 'gap-3',
    md: 'gap-5',
    lg: 'gap-8',
    xl: 'gap-12',
  } as const;
  return <div className={cn('flex flex-col', gapMap[gap], className)} {...props} />;
}

export function Row({
  className,
  gap = 'md',
  ...props
}: HTMLAttributes<HTMLDivElement> & { gap?: 'xs' | 'sm' | 'md' | 'lg' }) {
  const gapMap = { xs: 'gap-1.5', sm: 'gap-3', md: 'gap-5', lg: 'gap-8' } as const;
  return <div className={cn('flex flex-wrap items-center', gapMap[gap], className)} {...props} />;
}
